import React, { useEffect } from 'react';
import MiniTrackComponent from './MiniTrackComponent.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import { connect } from "react-redux";

function AdvancedKeysDocumentation(props) {
    useEffect(() => {
        if (props.sequencerEngine.subSequences[0] !== undefined) {
            props.sequencerEngine.switchToSubSequence(
                props.sequencerEngine.subSequences[0].id);
        }

        props.sequencerEngine.scripting.viCommand('d');
        props.sequencerEngine.scripting.viCommand('d');
    }, [0]);

    return (
        <div>

          <p className="sub-header">
            Command Mode (VIM Mode)
          </p>
          <p>
            Zequencer allows <a href="https://www.vim.org/">VIM-like</a> key-bindings for moving around and editing the sequence using the keyboard.
          </p>
          <p>
            Press the <b>escape key</b> to enter and exit <b>Command Mode</b>. You will see the following button in the top toolbar when in this mode:
          </p>
          <ConditionedComponent condition={props.viMode}>
            <div className="roll-button command-button">COMMAND</div>
            <div className="clear-fix"/>
          </ConditionedComponent>
          <p>
            The blinking <b>cursor</b> is central to <b>Command Mode</b>. There are several key-bindings for moving the <b>cursor</b>, when in <b>Command Mode</b>.
          </p>
          <MiniTrackComponent sequencerEngine={props.sequencerEngine}/>
          <p className="shortcuts">
            <ul>
              <li>
                <b>t</b>: toggles the step at cursor on/off.
              </li>
              <li>
                <b>h</b>: moves the cursor left one step.
              </li>
              <li>
                <b>j</b>: moves the cursor down one line.
              </li>
              <li>
                <b>k</b>: moves the cursor up one line.
              </li>
              <li>
                <b>l</b>: moves the cursor right one step.
              </li>
              <li>
                <b>w</b>: moves the cursor to the next cluster of steps.
              </li>
              <li>
                <b>b</b>: moves the cursor to the previous cluster of steps.
              </li>
              <li>
                <b>0</b>: moves the cursor to the beginning of the line
              </li>
              <li>
                <b>x</b>: deletes the step at the cursor, adding the step to the clipboard.
              </li>
              <li>
                <b>p</b>: pastes the clipboard at the cursor.
              </li>
              <li>
                <b>yy</b>: copies the current line into the clipboard.
              </li>
              <li>
                <b>dd</b>: deletes the current line, adding the steps to the clipboard.
              </li>
              <li>
                <b>dw</b>: deletes the next cluster of steps, adding the steps to the clipboard.
              </li>
              <li>
                <b>a</b>: doubles the track length.
              </li>
              <li>
                <b>s</b>: halves the track length.
              </li>
              <li>
                <b>i</b>: increase the duration of the step at the cursor by 1.
              </li>
              <li>
                <b>o</b>: decerease the duration of the step at the cursor by 1.
              </li>
            </ul>
          </p>
          <p className="sub-header">
            Compound Commands
          </p>
          <p>
            Typing a number within a command allows to repeatedly apply a command.
          </p>
          <p>
            for example, <b>d2d</b> will delete the 2 lines starting at the cursor, adding the steps to the clipboard.
          </p>
          <p>
            <b>y2y</b> will add the 2 lines to the clipboard.
          </p>
          <p>
            <b>d2w</b> will delete the next 2 clusters of steps, adding them to the clipboard.
          </p>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        viMode: state.commands.viMode,
    };
};
 
export default connect(mapStateToProps, undefined)(AdvancedKeysDocumentation);
